import { render, staticRenderFns } from "./StudentToolbar.vue?vue&type=template&id=64d910fc&"
import script from "./StudentToolbar.vue?vue&type=script&lang=js&"
export * from "./StudentToolbar.vue?vue&type=script&lang=js&"
import style0 from "./StudentToolbar.vue?vue&type=style&index=0&id=64d910fc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports